import { useLocalStorage } from "usehooks-ts";

export const useOrdersTableColumnWidths = () => {
  const [columnWidths, setColumnWidths] = useLocalStorage<
    Record<string, number>
  >("useOrdersTableColumnWidths", {});

  return { columnWidths, setColumnWidths };
};
